import { observer } from 'mobx-react-lite';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { WGLoginForm } from './login-form';
import './login.scss';

export const WGLoginPage = () => {
  const siteKey_v3 = process.env.REACT_APP_RECAPTCHA_SITE_KEY_V3;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={siteKey_v3!}>
      <WGLoginForm />
    </GoogleReCaptchaProvider>
  );
};

export const WGLogin = observer(WGLoginPage);
